module.exports = __webpack_public_path__ + "static/img/qihangCompany.d63b45f0.png";